module.exports = __webpack_public_path__ + "img/num_layout_08.26bce44f.png";